import { Atom, useAtomValue } from 'jotai';
import { selectedAssemblyTemplateId as selectedAssemblyTemplateIdAtom } from '@/components/Analysis/state';
/**
 * Custom hook to get the selected assembly template ID.
 *
 * @param {Atom<string | undefined>} [atom] - Optional Jotai atom to use instead of the default selectedAssemblyTemplateIdAtom.
 * @returns {string | undefined} The currently selected assembly template ID or undefined if not set.
 */

export const useSelectedAssemblyTemplateId = (
  atom?: Atom<string | undefined>
): string | undefined => useAtomValue(atom ?? selectedAssemblyTemplateIdAtom);
